
import http from '../utils/httpRequest';


const getComplaintQuashList = (params) => {
    return http.post('/complaint/quash/list', { ...params },{baseURL:baseURL})
}

const getSingleComplaintQuash = (params) => {
    return http.get('/complaint/quash/get?id='+params,{baseURL:baseURL})
}
const getComplaintQuashSave = (params) => {
    return http.post('/complaint/quash/save', { ...params },{baseURL:baseURL})
}
const getComplaintQuashProcessSubmit = (params) => {
    return http.post('/complaint/quash/processSubmit', { ...params },{baseURL:baseURL})
}
const getComplaintQuashDelete = (params) => {
    return http.post('/complaint/quash/delete', { ...params },{baseURL:baseURL})
}
const getWorkflowgetInfo = (params) => {
    return http.get('/workflow/getInfo?processInstanceid='+params,{baseURL:baseURL})
}
const getTabCount = () => {
    return http.get('complaint/getTabCount',{baseURL:baseURL})
}

const complaintDelete = (params) => {
    return http.post('/complaint/delete', { ...params },{baseURL:baseURL})
}

const getByComplaintId = (params) => {
    return http.get('/complaint/quash/getByComplaintId?id='+params,{baseURL:baseURL})
}
export { 
    getComplaintQuashList,//列表
    getSingleComplaintQuash,//获取单条记录
    getComplaintQuashSave,
    getComplaintQuashProcessSubmit,
    getComplaintQuashDelete,
    getWorkflowgetInfo,
    getTabCount,
    complaintDelete,
    getByComplaintId
}